import { render, staticRenderFns } from "./TreeTest.vue?vue&type=template&id=615247f0&"
import script from "./TreeTest.vue?vue&type=script&lang=js&"
export * from "./TreeTest.vue?vue&type=script&lang=js&"
import style0 from "./TreeTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports